import axios from 'axios';
import Cookies from 'js-cookie';

const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? 'https://al-asala-restaurant.com'
    : 'http://localhost:8000',
  timeout: 600000,
  withCredentials: true,
  headers: {
    'X-XSRF-TOKEN': Cookies.get('XSRF-TOKEN'),
  },
});

export default instance;
